// extracted by mini-css-extract-plugin
export default {"section":"section-Dagx"};